/* eslint-disable no-loop-func */
import React, { useEffect, useState } from "react";
// import firebase from "firebase/app";
import { Button, Modal, Tab } from "semantic-ui-react";
// import resultJSON from "./result_v1.json";

import FormTab from "./FormTab";
function AutoFillModal({ uid, formArray }) {
  const [open, setOpen] = useState(false);
  const [panes, setPane] = useState([]);

  useEffect(() => {
    const panelArray = formArray.map((item) => {
      return {
        menuItem: item,
        render: () => (
          <Tab.Pane attached={false}>
            <FormTab formName={item} />
          </Tab.Pane>
        ),
      };
    });

    setPane([...panelArray]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formArray]);

  return (
    <Modal
      style={{
        minHeight: "95%",
        minWidth: "100%",
        marginTop: "0px",
      }}
      dimmer="blurring"
      closeOnDimmerClick={false}
      centered={false}
      size="fullscreen"
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={<Button fluid>Execute</Button>}
    >
      <Modal.Header></Modal.Header>
      <Modal.Content>
        {/* <Button onClick={() => handleRun()}>RUN</Button> */}
        <Tab menu={{ pointing: true }} panes={panes} />
      </Modal.Content>
      <Modal.Actions>
        <Button
          content="BACK"
          color="black"
          labelPosition="right"
          icon="reply"
          onClick={() => setOpen(false)}
        />
      </Modal.Actions>
    </Modal>
  );
}

export default AutoFillModal;

// const [data, setData] = useState([]);
// const pdfNames = Object.keys(pdfListEnum);

// const [formData, setFormData] = useState([]);
// const pdfNames = [
//   "g28",
//   "g1145",
//   "eoir28",
//   "i589",
//   "i485",
//   "i130",
//   "i131",
//   "i130a",
// ];

// for (let i = 0; i < pdfNames.length; i++) {
//   firebase
//     .firestore()
//     .collection("formFields")
//     .doc(pdfNames[i])
//     .get()
//     .then((doc) => {
//       const tempObj = obj;
//       tempObj[pdfNames[i]] = doc.data();
//       setObj(tempObj);
//     })
//     .catch((err) => {
//       global.alert(err);
//     });
// }

// const tempObj = {};
// const handleRun = () => {
//   const tempArr = [];

//   const personType = ["preparer", "interpreter", "primary", "secondary"];

//   for (let q = 0; q < personType.length; q++) {
//     for (let i = 0; i < resultJSON["i589"][personType[q]].length; i++) {
//       tempArr.push(resultJSON["i589"][personType[q]][i].key);
//     }
//     for (let i = 0; i < resultJSON["g28"][personType[q]].length; i++) {
//       tempArr.push(resultJSON["g28"][personType[q]][i].key);
//     }
//     for (let i = 0; i < resultJSON["eoir28"][personType[q]].length; i++) {
//       tempArr.push(resultJSON["eoir28"][personType[q]][i].key);
//     }
//     // for (let i = 0; i < resultJSON["i130a"][personType[q]].length; i++) {
//     //   tempArr.push(resultJSON["i130a"][personType[q]][i].key);
//     // }
//     const uniq = [...new Set(tempArr)];

//     // const preArray = uniq.map((item) => {
//     //   return { [item]: "" };
//     // });
//     const convertArrayToObject = (array, key) => {
//       const initValue = {};
//       return array.reduce((obj, item) => {
//         return {
//           ...obj,
//           [item]: "",
//         };
//       }, initValue);
//     };

//     const personTypeObj = convertArrayToObject(uniq);

//     tempObj[personType[q]] = personTypeObj;

//     // setObj({
//     //   [personType[q]]: personTypeObj,
//     // });
//     setObj(tempObj);
//     // console.log(tempObj);
//     // console.log(obj);

//     // finalObj[personType[q]] = preArray;
//   }

//   global.alert("Başarılı");
//   // global.alert(JSON.stringify(preArray));
// };

// async function handleChoose(e) {
//   e.preventDefault();
// }
